import React from 'react';

import classes from './Order.module.css';

const Order = (props) => {
	const ingredients = [];
	for (let ingredientName in props.ingredients) {
		ingredients.push({
			name: ingredientName,
			amount: props.ingredients[ingredientName],
		});
	}

	const ingredientsList = ingredients.map((i) => (
		<span key={i.name}>
			{i.name} : {i.amount}
		</span>
	));

	return (
		<div className={classes.Order}>
			<p className={classes.Ingredients}>Ingredients - {ingredientsList}</p>
			<p>
				Price : <strong>INR {props.price}</strong>
			</p>
		</div>
	);
};

export default Order;
